module.exports = __webpack_public_path__ + "img/Weapon_210.75ff602a.png";